module.exports = __webpack_public_path__ + "static/media/wsa_ba_2019.b7719421.jpg";